<template>
  <div class="content-box">
    <el-drawer
      title="花名册信息"
      :visible.sync="visible"
      direction="rtl"
      size="80%"
      ref="drawer"
      :wrapperClosable="false"
      :show-close="false"
    >
      <div class="form_class">
        <el-form
          :model="formData"
          ref="formRef"
          label-width="125px"
          :rules="formRules"
          :disabled="ifdisabled"
          style="margin-bottom: 100px;"
        >
          <el-tabs type="border-card">
            <el-tab-pane label="基本信息">
              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="10">
                  <el-form-item label="姓名：" prop="aid_user_name">
                    <el-input v-model="formData.aid_user_name" style="width:350px"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="身份证：" prop="card_no">
                    <el-input v-model="formData.card_no" style="width:350px"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="10">
                  <el-form-item label="项目名称：">
                    <el-input v-model="formData.project_name" disabled style="width:350px"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="项目阶段：" prop="report_id">
                    <el-select
                      v-model="formData.report_id"
                      placeholder="请选择项目阶段"
                      style="width:350px"
                    >
                      <el-option
                        :label="item.report_name"
                        :value="item.report_id"
                        v-for="item in stageList"
                        :key="item.report_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="10">
                  <el-form-item label="手机号：" prop="phone">
                    <el-input v-model="formData.phone" style="width:350px"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="贫困类型：" prop="poor_type">
                    <el-select
                      v-model="formData.poor_type"
                      placeholder="请选择贫困类型"
                      style="width:350px"
                    >
                      <el-option
                        :label="item.text"
                        :value="item.value"
                        v-for="item in poorType"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="10">
                  <el-form-item label="眼疾：" prop="eye_disease">
                    <el-select
                      v-model="formData.eye_disease"
                      placeholder="请选择眼疾"
                      style="width:350px"
                    >
                      <el-option
                        :label="item.text"
                        :value="item.value"
                        v-for="item in eyeDisease"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="眼别：" prop="eye_cate">
                    <el-select v-model="formData.eye_cate" placeholder="请选择眼别" style="width:350px">
                      <el-option
                        :label="item.text"
                        :value="item.value"
                        v-for="item in eyeCate"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="10">
                  <el-form-item label="地区" style="width:90%">
                    <WtDataArea v-if="flag" v-model="region" style="width:350px"></WtDataArea>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="详细地址：" prop="address">
                    <el-input v-model="formData.address" style="width:350px"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="10">
                  <el-form-item label="性别：" prop="sex">
                    <el-radio-group v-model="formData.sex">
                      <el-radio :label="1" border>男</el-radio>
                      <el-radio :label="2" border>女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="医保结算日期：">
                    <el-date-picker
                      v-model="formData.settlement_time"
                      type="date"
                      style="width:350px"
                      value-format="yyyy-MM-dd"
                      placeholder="选择医保结算日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="10">
                  <el-form-item label="申请时间：" prop="apply_time">
                    <el-date-picker
                      v-model="formData.apply_time"
                      type="date"
                      style="width:350px"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择申请时间"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="10">
                  <el-form-item label="入院时间：">
                    <el-date-picker
                      v-model="formData.access_time"
                      type="date"
                      style="width:350px"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择入院时间"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="10">
                  <el-form-item label="自费金额：" prop="own_amount">
                    <el-input-number
                      :min="0"
                      style="width:350px"
                      v-model.number="formData.own_amount"
                      :max="999999999"
                      :controls="false"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="医保报销金额：" prop="reimbursement_amount">
                    <el-input-number
                      :min="0"
                      style="width:350px"
                      v-model.number="formData.reimbursement_amount"
                      :max="999999999"
                      :controls="false"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="10">
                  <el-form-item label="项目救助金额：" prop="subsidized_amount">
                    <el-input-number
                      :min="0"
                      style="width:350px"
                      v-model.number="formData.subsidized_amount"
                      :controls="false"
                      :max="999999999"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="其他金额：" prop="others_amount">
                    <el-input-number
                      :min="0"
                      style="width:350px"
                      v-model.number="formData.others_amount"
                      :controls="false"
                      :max="999999999"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="left" :gutter="150">
                <el-col style="margin-left:8.3%" :span="10">
                  <el-form-item label="治疗总费用：" prop="total_amount">
                    <el-input-number
                      :min="0"
                      style="width:350px"
                      v-model.number="formData.total_amount"
                      :controls="false"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="20">
                  <el-form-item label="备注：" prop="comment">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="请输入备注"
                      v-model="formData.comment"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="相关图片" style="margin-bottom:50px">
              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="20">
                  <el-form-item label="身份证明：">
                    <el-upload
                      ref="uploadImg1"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-preview="showImg"
                      :data="uploadParms"
                      name="img"
                      :file-list="defImg1"
                      :before-upload="beforeUpload"
                      :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defImg1');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImg1');
                    }"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="20">
                  <el-form-item label="贫困证明：">
                    <el-upload
                      ref="uploadImg2"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-preview="showImg"
                      :data="uploadParms"
                      name="img"
                      :file-list="defImg2"
                      :before-upload="beforeUpload"
                      :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defImg2');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImg2');
                    }"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="20">
                  <el-form-item label="结算图片集：">
                    <el-upload
                      ref="uploadImg3"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-preview="showImg"
                      :data="uploadParms"
                      name="img"
                      :file-list="defImg3"
                      :before-upload="beforeUpload"
                      :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defImg3');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImg3');
                    }"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="20">
                  <el-form-item label="其它证明：" prop="other_pics">
                    <el-upload
                      ref="uploadImg4"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-preview="showImg"
                      :data="uploadParms"
                      name="img"
                      :file-list="defImg4"
                      :before-upload="beforeUpload"
                      :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defImg4');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImg4');
                    }"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" justify="center" :gutter="150">
                <el-col :span="20">
                  <el-form-item label="其它图集：" prop="pics">
                    <el-upload
                      ref="uploadImg5"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-preview="showImg"
                      :data="uploadParms"
                      name="img"
                      :file-list="defImg5"
                      :before-upload="beforeUpload"
                      :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defImg5');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImg5');
                    }"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
        <div class="demo-drawer-footer">
          <el-button type="danger" size="small" icon="el-icon-close" @click="close">关闭</el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-finished"
            @click="submitF(false)"
            :loading="loading"
            v-if="!ifdisabled"
          >保存</el-button>
          <el-button
            @click="submitF(true)"
            v-if="!ifdisabled"
            :loading="loading"
            icon="el-icon-s-promotion"
            type="primary"
            size="small"
          >提交</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import Axios from "axios";
export default {
  props: {
    // 项目id
    id: {
      type: Number,
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    },
    ifdisabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(value)) {
        return callback(new Error("手机号码格式不正确！"));
      } else {
        return callback();
      }
    };
    var checkUserCardno = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请填写身份证号码！"));
      }

      var isValid = true;
      var cityCode = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
      };
      var rFormat = /^\d{6}(19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$|^\d{6}\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}$/; // 格式验证

      if (!rFormat.test(value) || !cityCode[value.substr(0, 2)]) {
        isValid = false;
      }
      // 18位身份证需要验证最后一位校验位
      else if (value.length === 18) {
        var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
        var Ci = "10X98765432"; // 校验字符
        // 加权求和
        var sum = 0;
        for (var i = 0; i < 17; i++) {
          sum += value.charAt(i) * Wi[i];
        }
        // 计算校验值
        var C17 = Ci.charAt(sum % 11);
        // 与校验位比对
        if (C17 !== value.charAt(17)) {
          isValid = false;
        }
      }

      if (!isValid) {
        return callback(new Error("请填写正确的身份证号码！"));
      } else {
        return callback();
      }
    };
    return {
      defImg1: [],
      defImg2: [],
      defImg3: [],
      defImg4: [],
      defImg5: [],
      region: [],
      loading: false,
      eyeDisease: [],
      flag: true,
      eyeCate: [],
      poorType: [], // 贫困类型
      stageList: [], //项目阶段
      dialogImageUrl: null,
      dialogVisible: false,
      uploadImgUrl: null,
      formData: {
        aid_user_name: 2,
        access_time: null,
        card_no: null,
        phone: null,
        address: null,
        sex: null,
        address: null,
        eye_disease: null,
        eye_cate: null,
        poor_type: null,
        settlement_time: null,
        apply_time: null,
        access_time: null
      },
      formRules: {
        aid_user_name: [
          { required: true, message: "请输入姓名！", trigger: "blur" }
        ],
        card_no: [
          { required: true, message: "请输入身份证号码！", trigger: "blur" },
          { validator: checkUserCardno, trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号！", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],

        sex: [
          {
            required: true,
            type: "number",
            message: "请选择性别！",
            trigger: "change"
          }
        ],
        // region: [
        //   { validator: checkRegion, trigger: "blur" }
        // ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ],
        eye_disease: [
          {
            required: true,
            type: "number",
            message: "请选择眼疾！",
            trigger: "change"
          }
        ],

        eye_cate: [
          {
            required: true,
            type: "number",
            message: "请选择眼别！",
            trigger: "change"
          }
        ],
        poor_type: [
          {
            required: true,
            type: "number",
            message: "请选择贫困类型！",
            trigger: "change"
          }
        ],
        settlement_time: [
          { required: true, message: "请选择医保结算时间！", trigger: "change" }
        ],
        apply_time: [
          { required: true, message: "请选择申请时间！", trigger: "change" }
        ],
        access_time: [
          { required: true, message: "请选择入院时间！", trigger: "change" }
        ]
      },
      uploadImgUrl: "", // 上传到图片的地址
      uploadParms: { file_type: 2 }, //图片上传所需参数
      uploadPicParams: {} // 上传图片对象
    };
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit("input", false);
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    //预览图片
    showImg(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    //获取项目阶段
    getProjectStage(id) {
      this.$db
        .post(this.$db.config.getStageListByProId, { id: id })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.stageList = resp.data;
          }
        });
    },

    saveData(url) {
      this.loading = true;

      this.formData.other_pics = [];
      this.formData.pics = [];

      //其他证明图集
      if (this.defImg4 && this.defImg4.length > 0) {
        let pics = this.defImg4;
        pics.forEach(item => {
          if (item.hasOwnProperty("response")) {
            this.formData.other_pics.push(item.response.data.id);
          } else {
            this.formData.other_pics.push(item.id);
          }
        });
      }

      //其他图片集
      if (this.defImg5 && this.defImg5.length > 0) {
        let pics = this.defImg5;
        pics.forEach(item => {
          if (item.hasOwnProperty("response")) {
            this.formData.pics.push(item.response.data.id);
          } else {
            this.formData.pics.push(item.id);
          }
        });
      }
      if (this.region.length == 3) {
        this.formData.province_id = this.region[0];
        this.formData.city_id = this.region[1];
        this.formData.county_id = this.region[2];
      }
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.$db.post(url, this.formData).then(res => {
            this.loading = false;
            if (res && res.code == 200) {
              this.$message.success(res.msg);
              this.close();
              this.$emit("success");
            }
          });
        } else {
          this.loading = false;
          this.$message.error("请填写完整表单信息！");
          return false;
        }
      });
    },

    //保存提交操作
    submitF(flag = false) {
      this.formData.cardno_pics = [];
      this.formData.poor_pics = [];
      this.formData.settlement_pics = [];

      //身份证明图片集
      if (this.defImg1 && this.defImg1.length > 0) {
        let pics = this.defImg1;
        pics.forEach(item => {
          if (item.hasOwnProperty("response")) {
            this.formData.cardno_pics.push(item.response.data.id);
          } else {
            this.formData.cardno_pics.push(item.id);
          }
        });
      }
      // else {
      //   this.loading = false;
      //   this.$message.warning("身份证明照片不能为空！");
      //   return false;
      // }

      //贫困图片集
      if (this.defImg2 && this.defImg2.length > 0) {
        let pics = this.defImg2;
        pics.forEach(item => {
          if (item.hasOwnProperty("response")) {
            this.formData.poor_pics.push(item.response.data.id);
          } else {
            this.formData.poor_pics.push(item.id);
          }
        });
      }
      // else {
      //   this.loading = false;
      //   this.$message.warning("贫困图片集不能为空！");
      //   return false;
      // }

      //结算图片集
      if (this.defImg3 && this.defImg3.length > 0) {
        let pics = this.defImg3;
        pics.forEach(item => {
          if (item.hasOwnProperty("response")) {
            this.formData.settlement_pics.push(item.response.data.id);
          } else {
            this.formData.settlement_pics.push(item.id);
          }
        });
      }
      // else {
      //   this.loading = false;
      //   this.$message.warning("结算图片集不能为空！");
      //   return false;
      // }
      if (flag === true) {
        this.$confirm(
          "提交信息至基金会，信息将不能再做修改，是否继续？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.saveData(this.$db.config.comProListApplySubmit);
          })
          .catch(() => {});
      } else {
        this.saveData(this.$db.config.comProListApplyEdit);
      }
    },

    //获取眼疾眼别
    getDictInfo() {
      //贫困类型
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100380,
          table: "pub_type_param"
        })
        .then(res => {
          this.poorType = res.data;
        });

      // 眼疾
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100170,
          table: "pub_type_param"
        })
        .then(res => {
          if (res && res.code == 200) {
            this.eyeDisease = res.data;
          }
        });

      //眼别
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100430,
          table: "pub_dict"
        })
        .then(res => {
          if (res && res.code == 200) {
            this.eyeCate = res.data;
          }
        });
    }
  },
  created() {
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    this.visible = this.value;
    this.flag = false;
    this.getDictInfo();
    this.$db
      .post(this.$db.config.getComProListApplyDetails, {
        id: this.id
      })
      .then(res => {
        if (res && res.code == 200) {
          this.formData = res.data;
          this.defImg1 = res.data.cardno_pics_path;
          this.defImg2 = res.data.poor_pics_path;
          this.defImg3 = res.data.settlement_pics_path;
          this.defImg4 = res.data.other_pics_path;
          this.defImg5 = res.data.pics_path;
          this.getProjectStage(res.data.project_id);
          if (res.data.province_id && res.data.city_id && res.data.county_id) {
            this.region[0] = res.data.province_id;
            this.region[1] = res.data.city_id;
            this.region[2] = res.data.county_id;
          }
          this.flag = true;
        }
      });
  }
};
</script>

<style scoped>
.demo-drawer-footer {
  width: calc(80% - 32px);
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.form_class {
  padding: 10px;
}
.content-box /deep/ .el-drawer.rtl {
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Hospital/comproject/apply/info.vue